import React from 'react';
import {RefundStatusEnum} from "@/lib/helper/enumType";
import {Tag} from "antd";

function RefundStatusEnumComponent({text}) {

    if (!text) {
        return <span></span>
    } else {
        return <>
            <Tag color={RefundStatusEnum(text, 'color')}>{RefundStatusEnum(text)}</Tag>
        </>
    }

}

export default RefundStatusEnumComponent;